/* eslint-disable prettier/prettier */
<template>
  <transition tag="tbody" name="fade">
    <tr>
      <th class="text-center pt-4" scope="row">
        {{ sn }}
      </th>
      <td class="">
        <select
          class="form-control border border-dark py-0 px-2 rounded-0"
          @change="fetchGrades(item.name)"
          v-model="item.name"
        >
          <option value disabled selected>
            Choose Commodity
          </option>
          <option v-for="product in products" :key="product.id">
            {{ product.name }}
          </option>
        </select>
      </td>
      <td class="">
        <select
          class="form-control border border-dark py-0 px-2 rounded-0"
          @change="fetchPrice(item.grade)"
          v-model="item.grade"
        >
          <option value disabled selected>Choose Grade</option>
          <option value="export">Export Grade</option>
          <option
            :value="grade.name"
            v-for="(grade, index) in grades"
            :key="index"
          >
            {{ grade.name | capitalize }}
          </option>
          <!-- <option value="1" v-for="grade in ProductGrades">{{ grade }}</option> -->
        </select>
      </td>
      <td class="">
        <div class="input-group">
          <div class="input-group-prepend">
            <!-- <span class="input-group-text" id="">First and last name</span> -->
          </div>
          <select
            class="small form-control border border-dark px-2 py-0 rounded-0"
            style="max-width:90px"
            v-model="item.weight"
          >
            <option value="kg">Kg</option>
            <option value="tonne">Tonne</option>
          </select>
          <select
            class="form-control border border-dark py-0 px-2 rounded-0"
            v-model.number="item.qty"
          >
            <option value disabled selected>Choose Qty</option>
            <option v-if="item.weight == 't'" value="1">1 tonne</option>
            <option v-for="weight in weightRange" :key="weight" :value="weight"
              >{{ weight }} {{ item.weight }}</option
            >
          </select>
        </div>
      </td>
      <td class="pt-4">
        {{ price | currency("₦", 0) | placeholder("₦ 0") }}
      </td>
      <td class="pt-4 text-center">
        <span @click="deleteCartItem(item)" class="delete-btn"></span>
      </td>
    </tr>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { weightMixin } from "@/_mixins";

export default {
  name: "CartItem",
  mixins: [weightMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    serial: {
      type: Number,
      required: true
    }
  },

  created() {
    this.fetchGrades(this.item.name);
    this.fetchPrice(this.item.grade);
  },

  computed: {
    ...mapGetters("cart", ["products"]),
    sn() {
      return this.serial + 1;
    },
    weightRange() {
      return this.item.weight == "kg"
        ? this.range(100, 900, 100)
        : this.range(15, 120, 15);
    }
  },

  data() {
    return {
      grades: [],
      price: 0
    };
  },

  methods: {
    ...mapActions("cart", ["deleteCartItem"]),

    fetchGrades(productName) {
      let product = this.products.find(item => item.name === productName);
      this.grades = product ? product.grades : [];
    },
    fetchPrice(gradeName) {
      let grade = this.grades.find(g => g.name === gradeName);
      this.price = grade ? grade.price : 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.delete-btn {
  display: inline-block;
  cursor: pointer;
  width: 18px;
  height: 18px;
  background: url("/assets/images/delete-icn.svg") no-repeat center;
  // margin-right: 20px;
}
</style>
